import type { SettingsNavCategory } from '../settings.interface'
import { SETTINGS_MOBILE_DISABLED_NAV_ITEM_IDS } from '../settings-nav.const'

export function applyMobileSettingsNavDisabledState(items: SettingsNavCategory[]): SettingsNavCategory[] {
  return items.map((category) => ({
    ...category,
    items: category.items.map((item) =>
      SETTINGS_MOBILE_DISABLED_NAV_ITEM_IDS.has(item.id) ? { ...item, disabled: true } : item
    ),
  }))
}
